import React from "react";
import { Link } from "react-router-dom";

const WhyChooseUs = () => {
  return (
    <React.Fragment>
      <section id="whyus" style={{ padding: "60px 0" }}>
        <div className="container">
          <h2 className="section-title">Why FORMAX PAY?</h2>
          <p className="section-sub">
            Experience the power of instant commission &amp; upfront discounts.
          </p>
          <div className="why-grid">
            <div className="why-item">
              <div className="why-icon">
                <i className="fas fa-shield" />
              </div>
              <h4>100% Secure</h4>
              <p>Safe and protected transactions with reliable systems.</p>
            </div>
            <div className="why-item">
              <div className="why-icon">
                <i className="fas fa-bolt" />
              </div>
              <h4>Fast Processing</h4>
              <p>Instant recharge &amp; bill payment confirmation.</p>
            </div>
            <div className="why-item">
              <div className="why-icon">
                <i className="fas fa-headset" />
              </div>
              <h4>24/7 Support</h4>
              <p>Dedicated customer care &amp; instant resolution.</p>
            </div>
            <div className="why-item">
              <div className="why-icon">
                <i className="fas fa-gem" />
              </div>
              <h4>Upfront Discount</h4>
              <p>Save money on every recharge &amp; bill payment.</p>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default WhyChooseUs;
